import {
  Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious,
} from "@/components/ui/carousel";
import { Instagram } from "lucide-react";
import { SectionHeading } from "@/components/shared";
import { videoTestimonials, business } from "@/lib/site";

// One 9:16 Instagram reel embed rendered directly so a single click plays it.
const ReelCard = ({ id, index }) => (
  <div
    className="relative w-full overflow-hidden rounded-2xl bg-navy shadow-md aspect-[9/16]"
    data-testid={`video-testimonial-${index}`}
  >
    <iframe
      title={`Patient video testimonial ${index + 1}`}
      src={`https://www.instagram.com/reel/${id}/embed/`}
      className="absolute inset-0 h-full w-full"
      loading="lazy"
      scrolling="no"
      frameBorder="0"
      allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
      allowFullScreen
    />
  </div>
);

export const VideoTestimonials = ({ dark = false, eyebrow = "Video Testimonials", title = "Hear It From Our Patients", sub }) => {
  return (
    <div>
      <SectionHeading center light={dark} eyebrow={eyebrow} title={title} sub={sub} />
      <Carousel
        opts={{ align: "start", loop: true }}
        className="w-full px-10 sm:px-12"
        data-testid="video-testimonials-carousel"
      >
        <CarouselContent className="-ml-4">
          {videoTestimonials.map((id, i) => (
            <CarouselItem key={id} className="pl-4 basis-4/5 sm:basis-1/2 lg:basis-1/3 xl:basis-1/4">
              <ReelCard id={id} index={i} />
            </CarouselItem>
          ))}
        </CarouselContent>
        <CarouselPrevious
          data-testid="video-carousel-prev"
          className="left-0 h-11 w-11 border-none bg-brand-orange text-white hover:bg-brand-orange-dark hover:text-white disabled:opacity-40"
        />
        <CarouselNext
          data-testid="video-carousel-next"
          className="right-0 h-11 w-11 border-none bg-brand-orange text-white hover:bg-brand-orange-dark hover:text-white disabled:opacity-40"
        />
      </Carousel>
      <div className="text-center mt-8">
        <a
          href={business.socials.instagram}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="video-instagram-link"
          className={`inline-flex items-center gap-2 font-bold transition-colors ${dark ? "text-white hover:text-brand-orange" : "text-navy hover:text-brand-orange"}`}
        >
          <Instagram className="h-4 w-4" /> See more on Instagram
        </a>
      </div>
    </div>
  );
};

export default VideoTestimonials;
